import { createTheme } from "@mui/material/styles";

import { Category } from "../types";

declare module "@mui/material/styles" {
    interface Theme {
        colors: {
            [Category.Endurance]: string;
            [Category.Strength]: string;
            [Category.Mobility]: string;
            [Category.Relaxation]: string;
            [Category.Coordination]: string;
            [Category.Ai]: string;
        };
    }
    // allow configuration using `createTheme`
    interface ThemeOptions {
        colors?: {
            [Category.Endurance]: string;
            [Category.Strength]: string;
            [Category.Mobility]: string;
            [Category.Relaxation]: string;
            [Category.Coordination]: string;
            [Category.Ai]: string;
        };
    }
}

const theme = createTheme({
    palette: {
        primary: {
            main: "#19A49C",
            contrastText: "#fff",
        },
        secondary: {
            main: "#23DACF",
            contrastText: "#fff",
        },
        background: { default: "#fff" },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 800,
            lg: 1280,
            xl: 1920,
        },
    },
    colors: {
        [Category.Endurance]: "#4e3cb1",
        [Category.Strength]: "#58b9e6",
        [Category.Mobility]: "#a141a6",
        [Category.Relaxation]: "#AB92BF",
        [Category.Coordination]: "#5a920e",
        [Category.Ai]: "#E6735C",
    },
    components: {
        MuiToolbar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#19A49C",
                    background: "linear-gradient(0.25turn, #23DACF, #19A49C);",
                    color: "#fff",
                },
            },
        },
    },
});

export default theme;
